import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { worker } from 'common/mockServiceWorker/worker';
import { getErrorBoundary, initializeBugsnag } from 'common/utils/bugsnag';
import App from './app';
import reportWebVitals from './reportWebVitals';

const { REACT_APP_SHOULD_RUN_MSW } = process.env;

if (REACT_APP_SHOULD_RUN_MSW === 'true') {
  worker.start({ onUnhandledRequest: 'bypass' })
    .then((result) => console.warn('MSW started', result));
}

const container = document.getElementById('root');

initializeBugsnag();

const ErrorBoundary = getErrorBoundary(React);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
    ,
  </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
